import React,{Fragment, useState} from 'react';
import {userImg} from '../../lib/constants';
import RecordsTable from './recordsTable';
import {useFetch} from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';
import { formatDate } from '../../lib/helpers';

const notificationsHeaders = ["Image", "Title", "Body", "Created At"];

const mapResponseData = (data) => {
  const getTrimmedObj = (obj) =>{
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['image'] = obj.image || userImg;
    trimmedObj['title'] = obj.title;
    trimmedObj['body'] = obj.body;
    trimmedObj['createdAt'] =formatDate(new Date(obj.createdAt));
    return trimmedObj;
  }
  if (data){
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const Notifications = ({openMainModal}) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const {data, loading, totalCount} = useFetch(`notifications?page=${page}${searchParam}`, reload);

  return(
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={notificationsHeaders}
        records={mapResponseData(data)}
        openMainModal={openMainModal}
        reload={()=>toggleReload(r=> !r)}
        searchQuery={searchQuery}
        onSearch={onSearch}
      />

      <PaginationBar page={page} totalCount={totalCount} setPage={setPage}/>
    </Fragment>
  );
}
export default Notifications;